import { Box, Typography } from '@mui/material';
import { Button } from '../../../../Components/MUIs';
import BottomSheet from '../../../../Components/Ui/BottomSheet';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';

export default function BackClickBottomSheet({
  open,
  route = '/M_Permit',
  onSubmit,
}) {
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { popPage } = useAppNavigate();
  return (
    <BottomSheet
      open={open}
      onClose={() => dispatch(BottomSheetActions.CloseBottomSheet())}
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
        >
          작성 중인 내용을 취소하시겠어요?
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          이동하시면 지금까지 입력한 내용이 사라질 수 있어요.
        </Typography>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          gap: 3,
        }}
      >
        <Button
          name="취소"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: 'transparent',
            border: `1px solid #776D6D`,
            color: '#776D6D',
            boxShadow: 'none',
          }}
          onClick={() => {
            dispatch(BottomSheetActions.CloseBottomSheet());
          }}
        />
        <Button
          name="확인"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={() => {
            if (onSubmit) onSubmit();
            dispatch(BottomSheetActions.CloseBottomSheet());
            if (activeStep > 0) dispatch(CommonActions.decreaseStep());
            popPage();
          }}
        />
      </Box>
    </BottomSheet>
  );
}
